module.exports = __webpack_public_path__ + "img/arrow-right-3.aabe59c6.svg";